import { useTranslation } from 'react-i18next';

import type { DailyReportEntry } from '../../../api/types';
import styles from './DailyChart.module.css';

interface DailyChartProps {
  daily: DailyReportEntry[];
}

// Короткая подпись дня недели по локали интерфейса (UTC, чтобы ISO-дата не
// смещалась на соседний день из-за таймзоны).
function weekdayLabel(dateIso: string, locale: string): string {
  const date = new Date(`${dateIso}T00:00:00Z`);
  if (Number.isNaN(date.getTime())) {
    return dateIso;
  }
  return new Intl.DateTimeFormat(locale, { weekday: 'short', timeZone: 'UTC' }).format(date);
}

// PARA-105, AC-4: гистограмма по дням (уровень детализации — данные, не дизайн).
// PARA-122 (D11, AC-10): weekday-подпись слева (колонка 24px), бар в центре,
// значение справа (0-дни — пустой трек, --text-faint) — образец reports/DailyChart.jsx.
export function DailyChart({ daily }: DailyChartProps): JSX.Element {
  const { i18n } = useTranslation('reports');
  const max = Math.max(1, ...daily.map((entry) => entry.completed));

  return (
    <ul className={styles.chart} data-testid="daily-chart">
      {daily.map((entry) => (
        <li key={entry.date} className={styles.row}>
          <span className={styles.day}>{weekdayLabel(entry.date, i18n.language)}</span>
          <span className={styles.track}>
            {entry.completed > 0 && (
              <span className={styles.bar} style={{ width: `${(entry.completed / max) * 100}%` }} />
            )}
          </span>
          <span
            className={entry.completed > 0 ? styles.value : `${styles.value} ${styles.valueZero}`}
          >
            {entry.completed}
          </span>
        </li>
      ))}
    </ul>
  );
}
